import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import newLogo2 from "../image/logo.png";
import { getProduct } from "../services/productService";
import isoPng from "../image/Certificate/iso.png";
import isiPng from "../image/Certificate/isi.png";

function Footer() {
  const history = useHistory();
  const [productObj, setProductObj] = useState([]);

  const fetchData = async () => {
    try {
      const dataArray = await getProduct();
      const temp = dataArray.map((item) => item.data);
      setProductObj(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 0,
    });
    fetchData();
  }, []);

  const handleHistoryPath = (path) => {
    history.push({ pathname: path });
  };

  return (
    <footer className="w-full bg-slate-950 border-t border-slate-800/80 text-slate-400 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">

          {/* Brand Segment Column */}
          <div className="lg:col-span-2 flex flex-col space-y-4">
            <Link className="flex items-center space-x-3 group focus:outline-none" to="/">
              <div className="bg-white p-2 rounded-xl shadow-md flex items-center justify-center">
                <img
                  alt="PoloPipes Logo"
                  className="w-10 h-8 object-contain"
                  src={newLogo2}
                />
              </div>
              <div className="text-white flex flex-col justify-center">
                <span className="font-black tracking-tight leading-none text-2xl group-hover:text-orange-500 transition-colors">
                  PoloPipes
                </span>
                <span className="text-[10px] font-bold tracking-wide opacity-80 skew-x-[-6deg] mt-1 whitespace-nowrap text-orange-400">
                  Ultimate Solution of Water
                </span>
              </div>
            </Link>
            <p className="text-xs sm:text-sm text-slate-400 leading-relaxed max-w-sm pt-2">
              Leading PVC & PE pipe manufacturer delivering top-tier certified fluid infrastructure assets designed for efficiency, high performance, and long-term sustainability.
            </p>
          </div>

          {/* Products Dynamic Grid Column */}
          <div>
            <h3 className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider mb-3">
              Products
            </h3>
            <div className="w-8 h-0.5 bg-orange-500 rounded-full mb-4"></div>
            <ul className="space-y-2.5 text-xs sm:text-sm font-medium">
              {productObj?.slice(0, 8).map((item) => (
                <li key={item.id || item.title}>
                  <Link
                    to={`/product/${item.id}`}
                    className="hover:text-orange-500 transition-colors block"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About Navigation Column */}
          <div>
            <h3 className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider mb-3">
              About Us
            </h3>
            <div className="w-8 h-0.5 bg-orange-500 rounded-full mb-4"></div>
            <ul className="space-y-2.5 text-xs sm:text-sm font-medium">
              <li>
                <button
                  onClick={() => handleHistoryPath("/about")}
                  className="hover:text-orange-500 transition-colors text-left cursor-pointer focus:outline-none"
                >
                  About PoloPipes
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleHistoryPath("/history")}
                  className="hover:text-orange-500 transition-colors text-left cursor-pointer focus:outline-none"
                >
                  History
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleHistoryPath("/testimonials")}
                  className="hover:text-orange-500 transition-colors text-left cursor-pointer focus:outline-none"
                >
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Details Grid Column */}
          <div>
            <h3 className="text-xs sm:text-sm font-bold text-white uppercase tracking-wider mb-3">
              Contact Us
            </h3>
            <div className="w-8 h-0.5 bg-orange-500 rounded-full mb-4"></div>
            <ul className="space-y-4 text-xs sm:text-sm font-medium">
              <li className="flex items-start space-x-3">
                <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className="w-5 h-5 text-orange-500 shrink-0 mt-0.5">
                  <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <div className="flex flex-col">
                  <span className="text-white font-bold mb-0.5">Location</span>
                  <span className="text-slate-400 leading-normal">Palitpur Road, Dewandighi Mirjapur, Purba Bardhaman - 713102</span>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className="w-5 h-5 text-orange-500 shrink-0 mt-0.5">
                  <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div className="flex flex-col">
                  <span className="text-white font-bold mb-0.5">Call Us</span>
                  <div className="flex items-center space-x-1 text-slate-400">
                    <a href="tel:8759893275" className="hover:text-orange-500 transition-colors">
                      8759893275
                    </a>
                    <span>/</span>
                    <a href="tel:8759089771" className="hover:text-orange-500 transition-colors">
                      8759089771
                    </a>
                  </div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className="w-5 h-5 text-orange-500 shrink-0 mt-0.5">
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div className="flex flex-col">
                  <span className="text-white font-bold mb-0.5">Mail Us</span>
                  <a href="mailto:sales@polopvc.com" className="text-slate-400 hover:text-orange-500 transition-colors">sales@polopvc.com</a>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {/* Footer Bottom Division Row */}
        <div className="mt-12 pt-6 border-t border-slate-900">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 text-center sm:text-left">
            <p className="text-xs text-slate-500">
              &copy; {new Date().getFullYear()} POLO PVC PVT LTD&trade;. All Rights Reserved.
            </p>

            {/* Certification Marks & Social Container */}
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 sm:gap-6 px-4 py-3 bg-slate-900/60 rounded-2xl border border-slate-800/80 backdrop-blur-md">
              {/* ISO Mark */}
              <div className="w-12 h-12 rounded-xl bg-white p-1 flex items-center justify-center shadow-md cursor-pointer hover:scale-105 transition-transform" title="ISO 9001:2015 Certified">
                <img
                  src={isoPng}
                  alt="ISO Certified"
                  className="max-w-full max-h-full object-contain"
                />
              </div>

              {/* ISI Mark */}
              <div className="w-12 h-12 rounded-xl bg-white p-1 flex items-center justify-center shadow-md cursor-pointer hover:scale-105 transition-transform" title="ISI Marked">
                <img
                  src={isiPng}
                  alt="ISI Marked"
                  className="max-w-full max-h-full object-contain"
                />
              </div>

              {/* Divider */}
              <div className="w-px h-8 bg-slate-800 hidden sm:block"></div>

              {/* Social Channels */}
              <div className="flex items-center space-x-2">
                <a
                  href="https://www.facebook.com/profile.php?id=61553303713898"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-xl bg-slate-800/80 text-slate-400 hover:text-white hover:bg-orange-600 transition-all"
                  aria-label="Facebook"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
                <a
                  href="https://instagram.com/polo_pipes"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-xl bg-slate-800/80 text-slate-400 hover:text-white hover:bg-orange-600 transition-all"
                  aria-label="Instagram"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/polo-pvc-pvt-ltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-xl bg-slate-800/80 text-slate-400 hover:text-white hover:bg-orange-600 transition-all"
                  aria-label="LinkedIn"
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;